import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  cards: {
    height: 'auto',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      boxShadow: 'none',
      border: 'none',
      padding: '24px',
      borderRadius: '16px 16px 0px 0px',
    },
  },
  cardsHeader: {
    marginBottom: 56,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      textAlign: 'center',
      marginBottom: 24,
    },
  },
  container: {
    display: 'grid',
    gridTemplateColumns: '1fr 448px',
    width: '100%',
    gap: 16,
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
      gap: 0,
    },
  },
  illustrationContainer: {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  illustration: {
    width: '100%',
    height: 'auto',
    maxWidth: '336px',
  },
}))
